export const Locked = {
  name: 'Locked',
  value: 2,
};

export const Selected = {
  name: 'Selected',
  value: 1,
};

export const Default = {
  name: 'Default',
  value: 0,
};

export default {
  Locked,
  Selected,
  Default,
};
